module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "steps"
  }, [(_vm.editable) ? _c('div', {
    staticClass: "addStep0"
  }, [_c('button', {
    staticClass: "glyphicon glyphicon-plus add",
    attrs: {
      "id": "btn-add-step"
    },
    on: {
      "click": function($event) {
        return _vm.events.addStep(0)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      staticClass: "step",
      class: {
        'active': step.active
      }
    }, [(_vm.icons) ? _c('span', {
      staticClass: "glyphicon icon",
      class: {
        'glyphicon-ok': step.completed,
        'glyphicon-cog': !step.completed && !step.active,
        'glyphicon-refresh': step.active
      }
    }) : _c('span', {
      staticStyle: {
        "font-size": "36px",
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [(_vm.editable) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (step.name),
        expression: "step.name"
      }],
      staticClass: "form-control field-name",
      attrs: {
        "type": "text",
        "placeholder": "Nome"
      },
      domProps: {
        "value": (step.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(step, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (step.description),
        expression: "step.description"
      }],
      staticClass: "form-control field-description",
      attrs: {
        "type": "text",
        "placeholder": "Descrição"
      },
      domProps: {
        "value": (step.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(step, "description", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('multiselect', {
      attrs: {
        "id": "target",
        "label": "description",
        "track-by": "objectId",
        "options": _vm.groups,
        "showLabels": false,
        "placeholder": "Selecione o grupo"
      },
      model: {
        value: (step.target),
        callback: function($$v) {
          _vm.$set(step, "target", $$v)
        },
        expression: "step.target"
      }
    }), _vm._v(" "), (step.objectId) ? _c('div', {
      staticClass: "message"
    }, [_vm._v("\n            Para selecionar o grupo dinamicamente, "), _c('router-link', {
      attrs: {
        "to": {
          name: 'StepGroupRuleList',
          params: {
            stepId: step.objectId
          }
        }
      }
    }, [_vm._v(" clique aqui")]), _vm._v(".\n          ")], 1) : _c('div', {
      staticClass: "message"
    }, [_vm._v("\n            Salve o passo antes para definir as regras de grupo.\n          ")])], 1) : _c('div', [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(step.name))]), _vm._v(" "), _c('div', {
      staticClass: "step-resume"
    }, [(step.description) ? _c('div', {
      staticClass: "step-description"
    }, [_vm._v(_vm._s(step.description))]) : _vm._e(), _vm._v(" "), (step.target) ? _c('div', [_c('label', [_vm._v("Grupo Alvo:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(step.target.description))]), (_vm.request && _vm.request.dynamicStepGroup && _vm.request.currentStep.objectId === step.objectId) ? _c('span', [_vm._v(", mas dinamicamente alocado para "), _c('b', [_vm._v(_vm._s(_vm.request.dynamicStepGroup.description))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.editable) ? _c('div', {
      staticClass: "step-options"
    }, [_c('button', {
      staticClass: "glyphicon glyphicon-remove remove btn-remove-step",
      attrs: {
        "title": "Excluir passo"
      },
      on: {
        "click": function($event) {
          return _vm.events.removeStep(index)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "glyphicon glyphicon-plus add",
      attrs: {
        "title": "Adicionar passo"
      },
      on: {
        "click": function($event) {
          return _vm.events.addStep(index)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "glyphicon glyphicon-transfer add-trammit-fields",
      attrs: {
        "title": "Adicionar campos de Tramitação"
      },
      on: {
        "click": function($event) {
          return _vm.events.addFieldsToTrammit(step)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "glyphicon glyphicon-expand add-evaluate-fields",
      attrs: {
        "title": "Adicionar Ações Extras"
      },
      on: {
        "click": function($event) {
          return _vm.events.addExtraActions(step)
        }
      }
    })]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7f5d922"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/Steps.vue
// module id = 1423
// module chunks = 1